import { useEffect, useState } from 'react';
import { api, getUser } from '../api';
import { Modal, Field, Input, useToast, Loading } from '../ui';
import { Icons } from '../icons';

function TreeNode({ node, depth, onAdd, onEdit, onDel, canEdit, canDelete }: any) {
  const [open, setOpen] = useState(depth < 1);
  const hasKids = node.children?.length > 0;
  return (
    <div>
      <div className="tree-item" style={{ paddingLeft: depth * 22, display: 'flex', alignItems: 'center', gap: 6 }}>
        {hasKids ? <span className="tree-toggle" onClick={() => setOpen(!open)}>{open ? '▾' : '▸'}</span> : <span style={{ width: 14 }} />}
        <span style={{ fontWeight: depth === 0 ? 700 : 400 }}>📁 {node.name}</span>
        <span style={{ marginLeft: 8 }} className="act-row">
          {canEdit && <button className="act act-view" title="Ichki qo'shish" onClick={() => onAdd(node)}><Icons.plus size={16} /></button>}
          {canEdit && <button className="act act-edit" title="Tahrirlash" onClick={() => onEdit(node)}><Icons.edit size={15} /></button>}
          {canDelete && <button className="act act-del" title="O'chirish" onClick={() => onDel(node)}><Icons.trash size={15} /></button>}
        </span>
      </div>
      {open && hasKids && node.children.map((c: any) => (
        <TreeNode key={c.id} node={c} depth={depth + 1} onAdd={onAdd} onEdit={onEdit} onDel={onDel} canEdit={canEdit} canDelete={canDelete} />
      ))}
    </div>
  );
}

export default function Categories() {
  const [tree, setTree] = useState<any[] | null>(null);
  const [edit, setEdit] = useState<any>(null);
  const toast = useToast();
  const user = getUser();
  // backend bilan mos: yaratish/tahrir — admin va operator; o'chirish — faqat admin
  const canEdit = ['admin', 'zakaz_operator'].includes(user?.role);
  const canDelete = user?.role === 'admin';

  const load = () => api.get('/categories').then(setTree).catch((e) => { toast(e.message, true); setTree([]); });
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      if (edit.id) await api.patch('/categories/' + edit.id, { name: edit.name, code: edit.code });
      else await api.post('/categories', { name: edit.name, code: edit.code, parentId: edit.parentId });
      toast('Saqlandi'); setEdit(null); load();
    } catch (e: any) { toast(e.message, true); }
  };
  const del = async (n: any) => {
    if (!confirm(`«${n.name}» o'chirilsinmi?`)) return;
    try { await api.del('/categories/' + n.id); toast("O'chirildi"); load(); }
    catch (e: any) { toast(e.message, true); }
  };

  if (!tree) return <Loading />;

  return (
    <div>
      <div className="page-head">
        <div>
          <h1 className="page-title">Kategoriyalar</h1>
          <p className="page-sub">1C nomenklatura daraxti</p>
        </div>
        {canEdit && <button className="btn btn-primary" onClick={() => setEdit({ name: '', parentId: null })}>+ Ildiz kategoriya</button>}
      </div>
      <div className="card">
        {tree.map((n) => <TreeNode key={n.id} node={n} depth={0} canEdit={canEdit} canDelete={canDelete}
          onAdd={(p: any) => setEdit({ name: '', parentId: p.id, parentName: p.name })}
          onEdit={(n: any) => setEdit({ ...n })} onDel={del} />)}
      </div>
      {edit && (
        <Modal title={edit.id ? 'Tahrirlash' : (edit.parentName ? `«${edit.parentName}» ichida yangi` : 'Yangi ildiz kategoriya')} onClose={() => setEdit(null)}>
          <Field label="Nomi *"><Input value={edit.name} autoFocus onChange={(e) => setEdit({ ...edit, name: e.target.value })} /></Field>
          <Field label="Kod"><Input value={edit.code || ''} onChange={(e) => setEdit({ ...edit, code: e.target.value })} /></Field>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
            <button className="btn" onClick={() => setEdit(null)}>Bekor</button>
            <button className="btn btn-primary" onClick={save}>Saqlash</button>
          </div>
        </Modal>
      )}
    </div>
  );
}
